<quill-editor #quilleditor [class.is-invalid]="control.touched && control.invalid" [placeholder]="placeholder"
    [theme]="theme" [formControl]="control" [modules]="modules">
</quill-editor>


<div class="row no-gutters">
    <div class="col-8 ">
        <div-validation-message *ngIf="control.invalid && control.touched" [control]="control"
            [messageRequired]="messageRequired" [messagePattern]="messagePattern">
        </div-validation-message>
    </div>
    <div class="col-4 " *ngIf="characterAvailable >= 0">
        <small class="form-text text-right text-muted">{{characterAvailable}}
            {{characterAvailable===1?'caracter disponible':'caracteres disponibles'}} </small>
    </div>
</div>

